<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-text-box-plus-outline</v-icon>
        <h1 class="page-title">Add Document</h1>
      </v-layout>
    </div>
    <!-- <v-form>
      <input type="file" multiple="" @change="onFileChanged($event.target.files)" />
        <br />
        <button class="btn btn-primary" @click="onSubmit()" type="button">Upload File(s)</button>
    </v-form> -->

    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-text-field
            v-model="title"
            label="Title"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-row>
        <v-row>
          <v-file-input
            counter
            label="File input"
            loading="isLoading"
            placeholder="Select your file"
            prepend-icon="mdi-paperclip"
            outlined
            :show-size="1000"
            @change="onFileChanged"
          >
            <template v-slot:selection="{ index, text }">
              <v-chip
                v-if="index < 2"
                dark
                label
                small
              >
                {{ text }}
              </v-chip>

              <span
                v-else-if="index === 2"
                class="overline grey--text text--darken-3 mx-2"
              >
                +{{ files.length - 2 }} File(s)
              </span>
            </template>
          </v-file-input>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn outlined color="accent" class="mr-4" @click="onBack"
            >Back</v-btn
          >
          <v-btn
            outlined
            :disabled="!valid"
            class="mr-4"
            @click="onSubmit"
            >Submit</v-btn
          >
        </v-row>

        <div>
          <v-row>
            <v-col cols="12" lg="4" md="4" sm="12">
              <v-text-field
                v-model="fileName"
                readonly
                label="Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12">
              <v-text-field
                v-model="fileType"
                readonly
                label="Type"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12">
              <v-text-field
                v-model="fileSize"
                readonly
                label="Size"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="fileDate"
                readonly
                label="Last Modified Date"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-form>

    <div>
      <statusalert ref="alert" returnUrl="/schedule"></statusalert>
    </div>
  </div>
</template>

<script>
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'
import DocumentsService from '../../services/api/DocumentsService'
import store from '@/store/index.js'
import authorizedMixin from '../../mixins/authorizedMixin'
  

export default {
  props: ['eventId'],
  mixins: [authorizedMixin],

  components: {
    statusalert
  },

  store: store,

  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },

data() {
    return {
      documentId: 0,
      files: new FormData(),
      fileName: '',
      fileDate: '',
      fileType: '',
      fileSize: '',
      isLoading: false,
      result: null,
      valid: false,
      title: '',
      titleRules: [
        v => !!v || 'Title is required',
        v => v.length <= 80 || 'Name must be 80 characters or less'
      ]
    }
  },

  created() {
    if (!this.priviledged) {
      router.push('/unauth/')
    }
  },
  
  methods: {
    onBack() {
      router.push('/schedule')
    },
    onFileChanged(file) {
      if (file) {
        this.files = new FormData()
        this.files.append('file', file, file.name)
        this.fileName = file.name
        this.fileType = file.type
        this.fileDate = file.lastModifiedDate
        this.fileSize = file.size
      } else {
        this.fileName = ''
        this.fileType = ''
        this.fileDate = ''
        this.fileSize = ''
      }
    },
    onSubmit() {
      let me = this
      this.files.append('title', this.title)
      this.files.append('eventId', this.$route.query.eventId)
      if (this.files.length < 1) {
        const result = {
          isValid: false,
          statusCode: 404,
          errors: ['File is required']
        }
        this.$refs.alert.displayResult(result)
      } else {
        store.commit('isLoading')
        DocumentsService.create(this.files)
          .then(result => {
            me.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Document link created']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to add document']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.displayAlert()
          })
      }
    },
    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    }
  }
}
</script>

<style lang="scss" scoped></style>
